import { ArrowRight, ArrowDown, Check } from 'lucide-react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { useLanguage } from '../context/LanguageContext';

const RealEstatePage = () => {
  const { t } = useLanguage();
  
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      
      {/* Hero - Imagen tras navbar, full width, shadow abajo */}
      <section className="relative h-[50vh] md:h-screen pt-16 md:pt-24">
        <img 
          src="https://customer-assets.emergentagent.com/job_98176c5a-4141-45aa-866d-b1c1a8cb31e7/artifacts/v6t9afwt_7a40f4_b4ea21305c7748ec9f8397d8456570c4~mv2.avif"
          alt="Accretion Axiom Real Estate"
          className="w-full h-full object-cover object-center"
        />
        {/* Gradiente sutil - oscuro */}
        <div className="absolute bottom-0 left-0 right-0 h-32 bg-gradient-to-t from-gray-900 to-transparent"></div>
        
        {/* Flecha para scroll - solo desktop */}
        <button 
          className="hidden md:block absolute bottom-6 left-1/2 -translate-x-1/2 text-yellow-400 hover:text-yellow-300 transition-all animate-bounce cursor-pointer"
          onClick={() => {
            window.scrollTo({ top: window.innerHeight * 0.815, behavior: 'smooth' });
          }}
        >
          <ArrowDown size={52} strokeWidth={1.5} />
        </button>
      </section>

      {/* Services - Serio, con color en las cajas */}
      <section id="services" className="py-16 bg-white scroll-mt-48">
        <div className="max-w-6xl mx-auto px-4">
          <div className="text-center mb-12">
            <p className="text-sm tracking-[0.3em] mb-4 text-yellow-600">{t('realEstate.services')}</p>
            <h2 className="text-4xl md:text-5xl font-bold mb-8 text-gray-900">
              {t('realEstate.heroTitle')}
            </h2>
            <p className="text-lg text-gray-600 max-w-3xl mx-auto italic">
              {t('realEstate.heroDesc')}
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10">
            <div className="text-center p-10 bg-gradient-to-b from-gray-50 to-white border border-gray-100 rounded-2xl hover:shadow-xl transition-all duration-300 relative overflow-hidden group">
              <span className="absolute -top-2 left-2 text-[100px] font-bold text-gray-100/80 select-none pointer-events-none leading-none group-hover:text-purple-100/60 transition-colors">1</span>
              <div className="relative z-10">
                <img src="https://static.wixstatic.com/media/7a40f4_2e7316a2ef75432ea386baa620a12c4d~mv2.png" alt="AAC Real Estate" className="w-24 h-24 mx-auto mb-8 object-cover rounded-full shadow-lg ring-4 ring-purple-100" />
                <h3 className="text-lg font-bold mb-4 text-purple-600 tracking-wide">{t('realEstate.card1Title')}</h3>
                <p className="text-gray-600 text-sm leading-relaxed"><span className="italic text-gray-500">"{t('realEstate.card1Quote')}"</span> {t('realEstate.card1Desc')}</p>
                <p className="text-base font-bold text-gray-900 mt-6 pt-4 border-t border-gray-100">{t('realEstate.card1Footer')}</p>
              </div>
            </div>
            <div className="text-center p-10 bg-gradient-to-b from-gray-50 to-white border border-gray-100 rounded-2xl hover:shadow-xl transition-all duration-300 relative overflow-hidden group">
              <span className="absolute -top-2 left-2 text-[100px] font-bold text-gray-100/80 select-none pointer-events-none leading-none group-hover:text-purple-100/60 transition-colors">2</span>
              <div className="relative z-10">
                <img src="https://static.wixstatic.com/media/7a40f4_b0c9d423abf74b199e3fc5498a37a20d~mv2.jpg" alt="Luxury" className="w-24 h-24 mx-auto mb-8 object-cover rounded-full shadow-lg ring-4 ring-purple-100" />
                <h3 className="text-lg font-bold mb-4 text-purple-600 tracking-wide">{t('realEstate.card2Title')}</h3>
                <p className="text-gray-600 text-sm leading-relaxed"><span className="italic text-gray-500">"{t('realEstate.card2Quote')}"</span> {t('realEstate.card2Desc')}</p>
                <p className="text-base font-bold text-gray-900 mt-6 pt-4 border-t border-gray-100">{t('realEstate.card2Footer')}</p>
              </div>
            </div>
            <div className="text-center p-10 bg-gradient-to-b from-gray-50 to-white border border-gray-100 rounded-2xl hover:shadow-xl transition-all duration-300 relative overflow-hidden group">
              <span className="absolute -top-2 left-2 text-[100px] font-bold text-gray-100/80 select-none pointer-events-none leading-none group-hover:text-purple-100/60 transition-colors">3</span>
              <div className="relative z-10">
                <img src="https://static.wixstatic.com/media/7a40f4_6d77eac0a1d1404ba39c7f401f89480b~mv2.jpg" alt="Sourcing" className="w-24 h-24 mx-auto mb-8 object-cover rounded-full shadow-lg ring-4 ring-purple-100" />
                <h3 className="text-lg font-bold mb-4 text-purple-600 tracking-wide">{t('realEstate.card3Title')}</h3>
                <p className="text-gray-600 text-sm leading-relaxed"><span className="italic text-gray-500">"{t('realEstate.card3Quote')}"</span> {t('realEstate.card3Desc')}</p>
                <p className="text-base font-bold text-gray-900 mt-6 pt-4 border-t border-gray-100">{t('realEstate.card3Footer')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* AAC Real Estate I - Mismo estilo que Quantitative */}
      <section className="relative">
        <img 
          src="https://static.wixstatic.com/media/7a40f4_ac69b59d75b64e539b5b99025f85aacc~mv2.jpg"
          alt="Blueprint Background"
          className="w-full h-auto min-h-[850px] md:min-h-[650px] object-cover"
        />
        <div className="absolute inset-0 flex items-center justify-center px-4 py-8">
          <div className="bg-gray-900/90 backdrop-blur-sm p-6 md:p-10 lg:p-16 max-w-6xl w-full text-white shadow-2xl">
            <div className="grid grid-cols-1 lg:grid-cols-5 gap-8 items-center">
              {/* Contenido izquierda - 3 columnas */}
              <div className="lg:col-span-3">
                <p className="text-sm tracking-[0.2em] text-yellow-500 mb-4">1. THE BLUEPRINT</p>
                <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold mb-5">Fund: &ldquo;AAC REAL ESTATE I&rdquo;</h2>
                <p className="text-lg text-gray-300 mb-5">Institutional Strategy. Retail Access.</p>
                
                <p className="text-gray-400 mb-5 text-sm leading-relaxed italic">
                  Inside this confidential <span className="text-yellow-500 font-medium">Dossier PDF</span>: our complete thesis, ROI breakdown, and exit liquidity plan.
                </p>
                
                <p className="text-gray-400 mb-5 text-sm leading-relaxed">
                  We renovate undervalued properties in affordable areas, <span className="text-yellow-500 font-medium">creating new housing in Spain</span> while generating <span className="text-yellow-500 font-medium">+20% annualized returns</span>. Ethical real estate, fully backed by real assets.
                </p>
                
                <p className="text-gray-400 mb-8 text-sm leading-relaxed">
                  We leverage <span className="text-yellow-500 font-medium">connections, AI and Big Data</span> to source Top 1% deals (&lt;€110k). You invest, we execute the full cycle. Fiat, Crypto, or any capital accepted.
                </p>
                
                {/* Imagen documento - SOLO MÓVIL */}
                <div className="lg:hidden mb-6 flex justify-center">
                  <a href="https://beacons.ai/accretionaxiomcapital" target="_blank" rel="noopener noreferrer" className="group">
                    <div className="relative bg-gray-800 p-2 rounded-lg shadow-xl border border-gray-600">
                      <div className="bg-gray-700 px-2 py-1 rounded-t flex items-center gap-1 mb-1">
                        <div className="w-2 h-2 rounded-full bg-red-400"></div>
                        <div className="w-2 h-2 rounded-full bg-yellow-400"></div>
                        <div className="w-2 h-2 rounded-full bg-green-400"></div>
                        <span className="text-[8px] text-gray-400 ml-1">Dossier.pdf</span>
                      </div>
                      <img 
                        src="https://customer-assets.emergentagent.com/job_98176c5a-4141-45aa-866d-b1c1a8cb31e7/artifacts/v6t9afwt_7a40f4_b4ea21305c7748ec9f8397d8456570c4~mv2.avif"
                        alt="Investment Dossier"
                        className="w-64 h-auto rounded"
                      />
                    </div>
                  </a>
                </div>
                
                <div className="flex flex-row justify-center lg:justify-start gap-2 md:gap-4">
                  <a href="https://beacons.ai/accretionaxiomcapital" target="_blank" rel="noopener noreferrer" className="border-2 border-yellow-500 text-yellow-500 px-5 md:px-6 py-2.5 md:py-3 text-sm md:text-sm font-semibold hover:bg-yellow-500 hover:text-black transition-all inline-flex items-center">DOSSIER<ArrowRight className="ml-2" size={14} /></a>
                  <a href="#invest" className="bg-white text-black px-5 md:px-6 py-2.5 md:py-3 text-sm md:text-sm font-semibold hover:bg-gray-200 transition-all inline-flex items-center">INVEST<ArrowRight className="ml-2" size={14} /></a>
                </div>
              </div>
              {/* Separador vertical + documento - 2 columnas - DESKTOP */}
              <div className="hidden lg:flex lg:col-span-2 items-center justify-center gap-8">
                <div className="w-px bg-gray-600 self-stretch min-h-[300px]"></div>
                {/* Portada de documento estilizada */}
                <a href="https://beacons.ai/accretionaxiomcapital" target="_blank" rel="noopener noreferrer" className="flex flex-col items-center justify-center text-center flex-1 group cursor-pointer">
                  {/* Document-style frame */}
                  <div className="relative group-hover:scale-[1.02] transition-transform">
                    {/* Paper shadow effect */}
                    <div className="absolute -inset-2 bg-gradient-to-br from-yellow-500/20 to-gray-700/20 rounded-lg blur-sm group-hover:from-yellow-500/30 transition-all"></div>
                    {/* Document container */}
                    <div className="relative bg-gray-800 p-3 rounded-lg shadow-xl border border-gray-600 group-hover:border-yellow-500/50 transition-colors">
                      {/* Document header bar */}
                      <div className="bg-gray-700 px-3 py-1.5 rounded-t flex items-center gap-1.5 mb-2">
                        <div className="w-2.5 h-2.5 rounded-full bg-red-400"></div>
                        <div className="w-2.5 h-2.5 rounded-full bg-yellow-400"></div>
                        <div className="w-2.5 h-2.5 rounded-full bg-green-400"></div>
                        <span className="text-[9px] text-gray-400 ml-2">AAC_RealEstate_Dossier.pdf</span>
                      </div>
                      {/* Hero image as document cover */}
                      <img 
                        src="https://customer-assets.emergentagent.com/job_98176c5a-4141-45aa-866d-b1c1a8cb31e7/artifacts/v6t9afwt_7a40f4_b4ea21305c7748ec9f8397d8456570c4~mv2.avif"
                        alt="Investment Dossier Cover"
                        className="w-64 h-auto rounded shadow-inner"
                      />
                    </div>
                  </div>
                  <p className="text-xs text-gray-500 mt-4 italic group-hover:text-yellow-500 transition-colors">Full Investment Dossier</p>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Off-Market - Texto a la izquierda */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 items-center">
            {/* Imagen - arriba en móvil */}
            <div className="order-1 lg:order-2">
              <img 
                src="https://static.wixstatic.com/media/7a40f4_b0c9d423abf74b199e3fc5498a37a20d~mv2.jpg"
                alt="Off-Market Villa"
                className="w-full h-[250px] md:h-[500px] object-cover shadow-xl rounded-lg md:rounded-none"
              />
            </div>
            {/* Texto - abajo en móvil, alineado a la izquierda */}
            <div className="order-2 lg:order-1 lg:pr-8 text-left">
              <p className="text-sm tracking-[0.2em] text-yellow-600 mb-2">2.</p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">OFF-MARKET</h2>
              <p className="text-base md:text-lg text-yellow-600 mb-3 md:mb-4">Marbella. Villas. Hotels. Superyachts.</p>
              <p className="text-gray-600 italic mb-3 md:mb-4 text-sm md:text-base">True luxury is never listed on portals. It trades in whispers.</p>
              <p className="text-gray-600 mb-4 md:mb-6 leading-relaxed text-sm md:text-base">
                We bridge the gap between trophy assets and liquidity. We represent Sellers 
                looking for discreet exits and Buyers (Funds & Family Offices) ready to deploy capital.
              </p>
              <ul className="space-y-2 mb-6 md:mb-8 text-sm md:text-base text-left">
                <li className="flex items-center gap-2"><span className="text-yellow-600">•</span><span className="text-gray-700">For Sellers: Direct access to liquidity.</span></li>
                <li className="flex items-center gap-2"><span className="text-yellow-600">•</span><span className="text-gray-700">For Buyers: Access to off-market inventory.</span></li>
              </ul>
              <div className="flex justify-start">
              <a href="https://beacons.ai/accretionaxiomcapital" target="_blank" rel="noopener noreferrer" className="border-2 border-yellow-600 text-yellow-700 px-6 md:px-8 py-2.5 md:py-3 text-sm md:text-base font-semibold hover:bg-yellow-600 hover:text-white transition-all inline-flex items-center">DOSSIER<ArrowRight className="ml-2" size={16} /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* The Sniper - Texto a la izquierda */}
      <section className="py-12 md:py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 relative">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 items-center">
            {/* Imagen - arriba en móvil */}
            <div className="order-1">
              <img 
                src="https://static.wixstatic.com/media/7a40f4_6d77eac0a1d1404ba39c7f401f89480b~mv2.jpg"
                alt="Sniper Keys"
                className="w-full h-[250px] md:h-[500px] object-cover shadow-xl rounded-lg md:rounded-none"
              />
            </div>
            {/* Texto - abajo en móvil, alineado a la izquierda */}
            <div className="order-2 lg:pl-8 text-left">
              <p className="text-sm tracking-[0.2em] text-yellow-600 mb-2">3.</p>
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-3 md:mb-4">THE SNIPER</h2>
              <p className="text-base md:text-lg text-yellow-600 mb-3 md:mb-4">Direct Ownership. Institutional Execution.</p>
              <p className="text-gray-600 mb-4 md:mb-6 leading-relaxed text-sm md:text-base">
                For partners who demand full control. We act as your tactical team on the ground. 
                We identify the opportunity, negotiate the aggressive price, and deliver a turnkey 
                renovation plan with tenants secured from Day One.
              </p>
              <ul className="space-y-2 mb-6 md:mb-8 text-sm md:text-base text-left">
                <li className="flex items-center gap-2"><span className="text-yellow-600">•</span><span className="text-gray-700">Structure: Buy Solo or Joint Venture.</span></li>
                <li className="flex items-center gap-2"><span className="text-yellow-600">•</span><span className="text-gray-700">Asset: You hold the deed. We provide the edge.</span></li>
              </ul>
              <div className="flex justify-start">
              <a href="#" className="border-2 border-yellow-600 text-yellow-700 px-6 md:px-8 py-2.5 md:py-3 text-sm md:text-base font-semibold hover:bg-yellow-600 hover:text-white transition-all inline-flex items-center">REQUEST<ArrowRight className="ml-2" size={16} /></a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Off-Market Examples - Igual que HomePage */}
      <section className="py-0 bg-[#f5f5f0]">
        <div className="relative">
          {/* Fotos full width - apiladas en móvil, lado a lado en desktop */}
          <div className="grid grid-cols-1 lg:grid-cols-2">
            <img 
              src="https://static.wixstatic.com/media/7a40f4_515be14bd65e49aaa771633e04a80c31~mv2.jpg" 
              alt="Villa moderna" 
              className="w-full h-[250px] md:h-[650px] object-cover" 
            />
            <img 
              src="https://static.wixstatic.com/media/7a40f4_b0c9d423abf74b199e3fc5498a37a20d~mv2.jpg" 
              alt="Villa de lujo" 
              className="w-full h-[250px] md:h-[650px] object-cover" 
            />
          </div>
          
          {/* Tarjeta blanca - centrada encima de las imágenes */}
          <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-white py-6 md:py-10 px-6 md:px-12 shadow-2xl z-10 text-center mx-4 rounded-lg lg:rounded-none w-[90%] max-w-md lg:w-auto lg:max-w-none">
            <h2 className="text-xl md:text-3xl lg:text-4xl font-bold mb-2 md:mb-3 leading-tight">
              Some Off-Market<br />Opportunities
            </h2>
            <p className="text-[10px] md:text-sm text-gray-600 mb-2 md:mb-3 max-w-sm mx-auto">
              Examples of direct access to top properties and owners in Marbella, more places in Spain and Hotels globally like:
            </p>
            <ul className="text-[10px] md:text-sm text-gray-700 space-y-0.5 md:space-y-1 mb-3 md:mb-5">
              <li>- Villa Los Monteros (by Joaquín Torres)</li>
              <li>- Palais Monteverde</li>
            </ul>
            <a 
              href="/realestate" 
              className="bg-black text-white px-4 md:px-6 py-2 md:py-3 text-[10px] md:text-sm font-semibold hover:bg-gray-800 transition-all inline-flex items-center justify-center"
            >
              More Information
              <ArrowRight className="ml-1 md:ml-2" size={12} />
            </a>
          </div>
        </div>
      </section>

      {/* Ready to Execute - Fondo con imagen y esfera dorada */}
      <section className="relative py-40 overflow-hidden" data-testid="realestate-cta">
        {/* Background Image */}
        <img 
          src="https://static.wixstatic.com/media/c837a6_0f9a4576e86442e3b124952322acdd72~mv2.jpg"
          alt="City Skyline"
          className="absolute inset-0 w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gray-950/70"></div>
        
        {/* Esfera animada dorada de fondo */}
        <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
          <img 
            src="https://static.wixstatic.com/media/c837a6_159e86d4444649fcada7bff77ae670adf000.png"
            alt="Globe"
            className="w-[500px] h-[500px] object-contain opacity-40"
            style={{animation: 'float 6s ease-in-out infinite', filter: 'sepia(1) saturate(2) hue-rotate(-10deg)'}}
          />
        </div>
        
        {/* Contenido centrado */}
        <div className="relative z-10 max-w-4xl mx-auto px-4 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Ready to Execute?
          </h2>
          <p className="text-xl text-gray-300 mb-10 max-w-2xl mx-auto">
            Stop waiting. Start building wealth. Invest in AAC Real Estate I targeting +20% annualized returns backed by real assets.
          </p>
          <a 
            href="#" 
            className="bg-yellow-500 text-gray-950 px-12 py-5 text-xl font-bold hover:bg-yellow-400 transition-all inline-flex items-center"
            data-testid="final-invest-btn"
          >
            INVEST NOW
            <ArrowRight className="ml-3" size={24} />
          </a>
        </div>
      </section>

      {/* CSS para animación de flotación */}
      <style>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-20px); }
        }
      `}</style>

      <Footer />
    </div>
  );
};

export default RealEstatePage;
